var map = {
	"./1_citrus_cupcake.jpg": 40,
	"./2_cheese_cake.jpg": 41,
	"./3_fruit_cupcake.jpg": 42,
	"./4_citric_candy.jpg": 43,
	"./5_meringue.jpg": 44,
	"./6_raspberry_candy.jpg": 45,
	"./7_cake.jpg": 46,
	"./8_opium_cake.jpg": 47,
	"./9_donut1.jpg": 48
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 39;